// Bewusst nicht config/api importieren: dort steht import.meta, das Jest nicht
// parsen kann (bricht Tests aller Komponenten mit Quellenlogos).
const API_BASE = String(process.env.REACT_APP_API_BASE || "").replace(/\/+$/, "");

/**
 * Fremde Quellenlogos (Wikimedia, logos-world, gstatic ...) laden im Browser
 * oft nicht: Hotlink-/Referrer-Sperren, in China gesperrte Hosts, Wikimedia
 * liefert nur Standard-Thumbnailbreiten. Deshalb laufen externe Logo-URLs ueber
 * den Backend-Proxy GET /api/media/logo?url=..., der das Bild serverseitig
 * holt, prueft und cached. Relative URLs, data:-URLs und Bilder vom eigenen
 * Origin bleiben unveraendert.
 */
export function proxiedLogoUrl(url) {
  const raw = String(url ?? "").trim();
  if (!raw) return "";
  if (!/^https?:\/\//i.test(raw)) return raw; // relativ, data:, blob:, Asset-Import

  let parsed;
  try {
    parsed = new URL(raw);
  } catch {
    return raw;
  }

  if (typeof window !== "undefined" && parsed.origin === window.location.origin) {
    return raw;
  }
  // Bereits ueber den Proxy (z. B. doppelt aufgerufen) oder eigene API.
  if (/\/api\/(media\/logo|news\/placeholder)/i.test(parsed.pathname)) {
    return raw;
  }

  return `${API_BASE}/api/media/logo?url=${encodeURIComponent(raw)}`;
}

/** Bis zu zwei Initialen fuer den Platzhalter, z. B. "Wall Street Journal" -> "WS". */
export function sourceInitials(name) {
  const words = String(name ?? "")
    .replace(/https?:\/\/(www\.)?/i, "")
    .split(/[\s\-_.:/|]+/)
    .filter(Boolean);
  if (!words.length) return "";
  const first = Array.from(words[0]);
  if (words.length === 1) return first.slice(0, 2).join("").toUpperCase();
  return (first[0] + Array.from(words[1])[0]).toUpperCase();
}

/** onError-Handler fuer einfache <img>-Logos: kaputtes Bildsymbol ausblenden. */
export function hideBrokenImage(event) {
  const img = event?.currentTarget;
  if (img) img.style.display = "none";
}
